import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Media from 'components/common/Media'
import { formatProductId, loadSyndigoScript } from './helpers'

class SyndigoContent extends React.PureComponent {
  componentDidMount() {
    loadSyndigoScript(this.registerSyndigoProduct)
  }

  componentWillUnmount() {
    window.SYNDI && window.SYNDI.reset && window.SYNDI.reset()
  }

  setContainerElement = el => { this.containerElement = el }

  registerSyndigoProduct = () => {
    const syndigoElement = document.createElement('div')
    syndigoElement.setAttribute('id', 'syndi_inline')
    this.containerElement.appendChild(syndigoElement)
    const productId = formatProductId(this.props.productId)
    window.SYNDI = window.SYNDI || []
    window.SYNDI.push(productId)
  }

  render() {
    return <Wrapper ref={ this.setContainerElement } />
  }
}

SyndigoContent.propTypes = {
  productId: PropTypes.string
}

export default SyndigoContent

const Wrapper = styled.div`
  ${Media.mobile`
    padding: 15px;
  `}
`
